// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"1155": "c77c6b55","4156": "e1b0488e",}[chunkId] + ".css"
}